import { PdfTemplateModelType } from '@teinor/erp/types/company/config/pdfTemplate'
import { dictionaryComplexFromJsonArr } from '../../globals/dictionary'

export interface PdfQuoteOrderTemplatesAction {
    type: 'CHANGE_PDFQUOTEORDERTEMPLATE'
    payload: PdfTemplateModelType[]
}
export type DictionaryPdfQuoteOrderTemplate = { [id: number]: PdfTemplateModelType }
export type PdfQuoteOrderTemplatePayload = null | DictionaryPdfQuoteOrderTemplate

export default function pdfQuoteOrderTemplate(state: PdfQuoteOrderTemplatePayload = null, action: PdfQuoteOrderTemplatesAction): DictionaryPdfQuoteOrderTemplate | null {
    switch (action.type) {
        case 'CHANGE_PDFQUOTEORDERTEMPLATE':
            const dictionaryPdfQuoteOrderTemplateType = dictionaryComplexFromJsonArr(action.payload || [])
            return state = dictionaryPdfQuoteOrderTemplateType
        default:
            return state
    }
}